module.exports = __webpack_public_path__ + "static/img/logo.2f8656be.svg";